import { render, staticRenderFns } from "./backButton.vue?vue&type=template&id=79b90d52&scoped=true&"
import script from "./backButton.vue?vue&type=script&lang=js&"
export * from "./backButton.vue?vue&type=script&lang=js&"
import style0 from "./backButton.vue?vue&type=style&index=0&id=79b90d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b90d52",
  null
  
)

export default component.exports